/* KNOCDIC 2026-10-19: keep header language/country dropdowns open while the mouse moves from the button into the list.
   Cause: theme.js DropdownElement only listens mouseenter/mouseleave on the button, so leaving the button (towards the list) hides it instantly. */
(function () {
  var C = window.customElements && customElements.get('dropdown-localization');
  if (!C) return;
  var P = C.prototype, origHide = P.hide, origShow = P.show, DELAY = 300;
  function cancel(el) { if (el._kdHideTimer) { clearTimeout(el._kdHideTimer); el._kdHideTimer = null; } }
  P.show = function () { cancel(this); return this.open ? undefined : origShow.apply(this, arguments); };
  P.hide = function () {
    var ev = window.event, self = this;
    if (ev && ev.type === 'mouseleave' && !(window.theme && theme.config && theme.config.isTouch)) {
      cancel(self);
      self._kdHideTimer = setTimeout(function () { self._kdHideTimer = null; if (self.open) origHide.call(self); }, DELAY);
      return;
    }
    cancel(self);
    return origHide.apply(this, arguments);
  };
  function wire(el) {
    if (el._kdWired) return; el._kdWired = true;
    el.addEventListener('mouseenter', function () { cancel(el); });
    el.addEventListener('mouseleave', function () { if (el.open) el.hide(); });
  }
  document.querySelectorAll('dropdown-localization').forEach(wire);
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('dropdown-localization').forEach(wire); });
})();
